import React from 'react';

import {useModule} from '@/hooks/useModule';
import {ItemId, ItemType} from '../tags_module';
import {useModals} from '@/modules/music_sniper/components/modals/modals_provider';

type Props = {
    itemType: ItemType;
    itemId: ItemId;
};

export const AssignedTags = ({itemType, itemId}: Props) => {
    const tagsModule = useModule('Tags');
    const assignedTags = tagsModule.useTagsForItem(itemType, itemId);
    const modals = useModals();

    return (
        <div style={{border: '1px solid'}}>
            Assigned tags:
            <ul>
                {assignedTags.map(t => (
                    <li
                        key={t.tag}
                        onClick={async () => {
                            modals.openModal('ConfirmationModal', {
                                title: `Remove "${t.tag}" tag?`,
                                message: 'The tag will be removed from this item.',
                                confirmLabel: 'Remove',
                                danger: true,
                                onConfirm: () => {
                                    tagsModule.removeTagFromItem(t.item_type, t.item_id, t.tag);
                                },
                            });
                        }}
                    >
                        {t.tag}
                    </li>
                ))}
            </ul>
        </div>
    );
}
